import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface BaseAvatarProps {
  classNames?: { avatar?: string; image?: string; fallback?: string };
  imageSrc?: string;
  initials: string;
  onClick?: () => void;
}

export const BaseAvatar = React.forwardRef<HTMLDivElement, BaseAvatarProps>(
  ({ classNames, imageSrc, initials = 'DM', onClick }, ref) => {
    return (
      <Avatar ref={ref} className={classNames?.avatar} onClick={onClick}>
        <AvatarImage className={classNames?.image} src={imageSrc} alt="ser avatar" />
        <AvatarFallback className={classNames?.fallback}>{initials}</AvatarFallback>
      </Avatar>
    );
  }
);

BaseAvatar.displayName = 'BaseAvatar';
